@if (model$|async; as model) {
    <div>
        <div #fullSearchSpinnerDiv class="d-none">
            <aimo-spinner></aimo-spinner>
        </div>

        <div class="row">
            @for (product of model?.products; track product.code; let idx = $index) {
                <aimo-product-grid-item
                    [idSuffix]="'search_product_' + idx"
                    [gtmProductAttributes]="createGtmAttributes(idx, product)"
                    [product]="product"
                    [showComparison]="false"
                    class="col-6 col-sm-6 col-md-4 col-xl-auto"></aimo-product-grid-item>
            }
        </div>
    </div>
    <aimo-cx-page-size
        [model]="model"
        [isSelectComponent]="false"
        (pageSizeEvent)="changeListingProducts($event, 0)">
    </aimo-cx-page-size>
}

